/* Craftmark custom stencil builder (snippets/cm-stencil-builder.liquid).
   Counts the characters typed, picks the matching "Characters" variant (so extra characters are charged),
   draws the live preview and saves a picture of it with the cart line. */
(function () {
  'use strict';
  var wrap = document.getElementById('cm-stencil');
  if (!wrap) return;
  var cfg = {}; try { cfg = JSON.parse(document.getElementById('cm-stencil-cfg').textContent) || {}; } catch (e) {}
  var INCL = cfg.included || 16, FEES = cfg.extraBySize || {}, FEE0 = cfg.extra || 1, MAX = cfg.max || 40, OPT = cfg.option || 'Characters', BASE = cfg.baseLabel || ('Up to ' + INCL);
  var NS = 'http://www.w3.org/2000/svg', svg = document.getElementById('cm_stencil_svg');
  var FONT = '"Craftmark Stencil", "Stencil", "Arial Black", Arial, sans-serif';
  var MAT = {
    plastic:  { stops: [['0', '#b9c1c8'], ['.5', '#a7b0b8'], ['1', '#959fa8']], edge: '#7c8791' },
    aluminum: { stops: [['0', '#e3e6e9'], ['.25', '#c9cdd1'], ['.5', '#eceef0'], ['.75', '#bfc4c9'], ['1', '#d9dcdf']], edge: '#9aa0a6' },
    brass:    { stops: [['0', '#e8cf6a'], ['.3', '#cfae3c'], ['.55', '#f0dc86'], ['.8', '#c8a534'], ['1', '#dcc257']], edge: '#a88a22' }
  };
  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function money(n) { return '$' + n.toFixed(2); }
  function inputs() { return [].slice.call(document.querySelectorAll('#custom_product_form [data-text-line]')).filter(function (i) { return !i.disabled; }); }
  function lines() { return inputs().map(function (i) { return (i.value || '').toUpperCase().replace(/\s+/g, ' ').trim(); }).filter(Boolean); }
  function count() { return lines().join('').replace(/\s/g, '').length; }
  function sizeSel() { return document.getElementById('ProductSelect-0'); }
  function charSel() { var s = null; [].forEach.call(document.querySelectorAll('.product_option_select'), function (x) { if (x.getAttribute('data-option-label') === OPT) s = x; }); return s; }
  function fee() { var ss = sizeSel(), v = ss ? ss.value : ''; return FEES[v] != null ? FEES[v] : FEE0; }
  function fire(e) { e.dispatchEvent(new Event('change', { bubbles: true })); }

  var box = null;
  function counterBox() {
    if (box) return box;
    var ins = inputs(), last = ins[ins.length - 1]; if (!last) return null;
    var row = last.closest('.product_variation_field') || last.parentElement;
    box = document.createElement('div'); box.className = 'cm-st-count'; box.setAttribute('aria-live', 'polite');
    row.parentElement.insertBefore(box, row.nextSibling);
    return box;
  }

  function draw() {
    var L = lines(), ghost = !L.length; if (ghost) L = ['YOUR TEXT'];
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var m = MAT[cfg.material] || MAT.plastic, id = 'st' + Math.random().toString(36).slice(2, 7), defs = el('defs', {}, svg);
    var g = el('linearGradient', { id: id, x1: 0, y1: 0, x2: 1, y2: 1 }, defs);
    m.stops.forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, g); });
    var f = el('filter', { id: id + 's', x: '-5%', y: '-20%', width: '110%', height: '150%' }, defs);
    el('feDropShadow', { dx: 0, dy: 5, stdDeviation: 7, 'flood-color': '#000', 'flood-opacity': '.22' }, f);
    var W = 1000, padX = 70, maxW = W - 2 * 30 - 2 * padX, FS = 120, texts = [], widest = 1;
    var plate = el('rect', { x: 30, y: 24, width: W - 60, height: 10, rx: 4, fill: 'url(#' + id + ')', stroke: m.edge, 'stroke-width': 1.5, filter: 'url(#' + id + 's)' }, svg);
    L.forEach(function (t) {
      var tx = el('text', { x: W / 2, y: 0, 'text-anchor': 'middle', 'font-family': FONT, 'font-weight': '700', 'font-size': FS, fill: '#ffffff' }, svg);
      tx.textContent = t; if (ghost) tx.setAttribute('fill-opacity', '.6');
      var w = 1; try { w = tx.getComputedTextLength(); } catch (e) {}
      widest = Math.max(widest, w); texts.push(tx);
    });
    var fs = Math.min(FS, FS * maxW / widest), lh = fs * 1.12, padY = Math.max(34, fs * .42), y = 24 + padY + fs * .78;
    texts.forEach(function (tx) { tx.setAttribute('font-size', fs.toFixed(1)); tx.setAttribute('y', y.toFixed(1)); y += lh; });
    var ph = padY * 2 + lh * texts.length - (lh - fs) - fs * .04;
    plate.setAttribute('height', ph.toFixed(1));
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + Math.round(ph + 60));
  }

  function update() {
    var n = count(), extra = Math.max(0, n - INCL), over = n > MAX, cs = charSel(), b = counterBox(), FEE = fee();
    if (cs && !over) { var want = extra ? String(n) : BASE; if (cs.value !== want) { cs.value = want; if (cs.value === want) fire(cs); } }
    if (b) {
      if (over) { b.className = 'cm-st-count bad'; b.textContent = n + ' characters. Online ordering covers up to ' + MAX + ' characters per stencil. Please shorten the wording or call 1-800-627-5255 for a quote.'; }
      else if (extra) { b.className = 'cm-st-count extra'; b.textContent = n + ' characters: ' + INCL + ' included, plus ' + extra + ' extra at ' + money(FEE) + ' each (+' + money(extra * FEE) + ' per stencil). Spaces are not counted.'; }
      else { b.className = 'cm-st-count'; b.textContent = n + ' of ' + INCL + ' included characters used. Extra characters are ' + money(FEE) + ' each, up to ' + MAX + ' characters. Spaces are not counted.'; }
    }
    var ss = sizeSel(), sv = ss && ss.value && ss.value !== '0' ? ss.value : '';
    document.getElementById('cm_st_size').textContent = sv || ' ';
    document.getElementById('cm_st_chars').textContent = n;
    document.getElementById('cm_st_extra').textContent = over ? '—' : (extra ? '+' + money(extra * FEE) : 'None');
    draw();
  }

  // ---- picture of the preview for the cart / invoice ----
  var fontData = null;
  function fontCss() {
    if (fontData !== null) return Promise.resolve(fontData);
    return fetch(wrap.getAttribute('data-font')).then(function (r) { return r.blob(); }).then(function (bl) {
      return new Promise(function (ok) { var fr = new FileReader(); fr.onload = function () { ok(fr.result); }; fr.onerror = function () { ok(''); }; fr.readAsDataURL(bl); });
    }).then(function (d) { fontData = d ? '@font-face{font-family:"Craftmark Stencil";font-weight:700;src:url(' + d + ')}' : ''; return fontData; }).catch(function () { fontData = ''; return ''; });
  }
  function snapshot() {
    var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
    if (!uc || !uc.fileFrom || !pk) return Promise.resolve(null);
    return fontCss().then(function (css) {
      return new Promise(function (ok) {
        var done = false, fin = function (v) { if (!done) { done = true; ok(v); } };
        setTimeout(function () { fin(null); }, 12000);
        try {
          var vb = svg.viewBox.baseVal, c = svg.cloneNode(true), Wp = 1000, Hp = Math.round(Wp * vb.height / vb.width);
          c.setAttribute('width', Wp); c.setAttribute('height', Hp);
          if (css) { var st = document.createElementNS(NS, 'style'); st.textContent = css; c.insertBefore(st, c.firstChild); }
          var img = new Image();
          img.onload = function () {
            var cv = document.createElement('canvas'); cv.width = Wp; cv.height = Hp;
            var ctx = cv.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, Wp, Hp); ctx.drawImage(img, 0, 0, Wp, Hp);
            cv.toBlob(function (bl) {
              if (!bl) return fin(null);
              uc.fileFrom('object', new File([bl], 'stencil-preview.png', { type: 'image/png' }), { publicKey: pk })
                .done(function (info) { fin(info.cdnUrl + '-/preview/1200x1200/'); }).fail(function () { fin(null); });
            }, 'image/png');
          };
          img.onerror = function () { fin(null); };
          img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(c));
        } catch (e) { fin(null); }
      });
    });
  }
  function setProp(form, name, val) {
    var e = form.querySelector('input[type=hidden][name="properties[' + name + ']"]');
    if (!val) { if (e) e.remove(); return; }
    if (!e) { e = document.createElement('input'); e.type = 'hidden'; e.name = 'properties[' + name + ']'; form.appendChild(e); }
    e.value = val;
  }
  var pass = false;
  window.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('#add_button');
    if (!btn) return;
    if (pass) { pass = false; return; }
    var form = btn.closest('form'); if (!form) return;
    var n = count(), b = counterBox();
    if (!n || n > MAX) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      if (!n && b) { b.className = 'cm-st-count bad'; b.textContent = 'Type the wording for your stencil first.'; }
      var first = inputs()[0]; if (first) first.focus();
      return;
    }
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (btn.classList.contains('cm-saving')) return;
    update();
    inputs().forEach(function (i) { i.value = (i.value || '').toUpperCase().replace(/\s+/g, ' ').trim(); });
    setProp(form, 'Character Count', n + (n > INCL ? ' (' + (n - INCL) + ' extra)' : ''));
    var label = btn.innerHTML; btn.classList.add('cm-saving'); btn.innerHTML = 'Saving your design…';
    snapshot().then(function (url) {
      setProp(form, 'Design Preview', url);
      btn.classList.remove('cm-saving'); btn.innerHTML = label;
      pass = true; btn.click();
    });
  }, true);

  function init() {
    var cs = charSel();
    if (cs) { var row = cs.closest('.product_variation_field'); if (row) row.classList.add('cm-st-hidden'); }
    document.addEventListener('input', function (e) {
      var t = e.target; if (!t || !t.matches || !t.matches('[data-text-line]')) return;
      var v = t.value, up = v.toUpperCase();
      if (v !== up) { var s = t.selectionStart, en = t.selectionEnd; t.value = up; try { t.setSelectionRange(s, en); } catch (err) {} }
      update();
    });
    document.addEventListener('change', function (e) { if (e.target && e.target.id === 'ProductSelect-0') setTimeout(update, 0); });
    update();
    if (document.fonts && document.fonts.load) document.fonts.load('700 40px "Craftmark Stencil"').then(update);
    setTimeout(update, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
